<template>
  <div class="content-item item-width flex align-items-center">
    <div class="content-item-label">姓名</div>
    <el-select
      class="select-role"
      v-model="selectOriginalAuthorId"
      filterable
      :disabled="app_type === 'man'"
      remote
      reserve-keyword
      placeholder="请输入关键词"
      :remote-method="remoteMethod"
      :loading="loading"
      clearable
    >
      <el-option
        v-for="item in authorOptions"
        :key="item.originalAuthorId"
        :label="`${item.originalAuthorName} ${item.originalAuthorTitle} ${item.originalAuthorUnit} ${item.originalAuthorUnit}`"
        :value="item.originalAuthorId"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { request } from "@/utils/axios";
export default {
  name: "originalAuthor",
  props: ["functionIds"],
  data() {
    return {
      loading: false,
      authorOptions: [],
      selectOriginalAuthorId: "",
    };
  },
  methods: {
    remoteMethod(query) {
      console.log("进入这里了22222");
      if (query !== "") {
        this.loading = true;
        this.getOriginalAuthorsByName(query);
      } else {
        this.authorOptions = [];
      }
    },
    getOriginalAuthorsByName(query) {
      request(this.functionIds.getOriginalAuthors, {
        tenantId: this.$commonJs.getTenantId(),
        doctorName: query,
      })
        .then((res) => {
          let arr = [];
          if (res && res.length > 0) {
            arr = res.map((item) => ({
              originalAuthorId: item.docId,
              originalAuthorName: item.docName,
              originalAuthorTitle: item.docTitleName,
              originalAuthorUnit: item.hospitalName,
              ...item,
            }));
          }
          console.log("转化后的医生信息------ 59", arr);
          this.authorOptions = arr;
          this.loading = false;
        })
        .catch((err) => {
          this.authorOptions = [];
          this.loading = false;
        });
    },
    mapAuthorOptions() {
      console.log(
        "mapAuthorOptions",
        this.authorOptions,
        this.selectOriginalAuthorId
      );
      for (let i = 0; i < this.authorOptions.length; i++) {
        if (
          (this.authorOptions[i].docId ||
            this.authorOptions[i].originalAuthorId) ==
          this.selectOriginalAuthorId
        ) {
          return this.authorOptions[i];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-input) {
  width: 600px !important;
}
:deep(.el-input__icon) {
  line-height: 32px;
}
</style>
